import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css']
})
export class CadastroComponent implements OnInit {
  slideOneForm: FormGroup;
  jsonArraySegmento: any;
  jsonCidadeEstado: any;
  jsonArrayCidades: any;
  jsonArrayEstados:any;

  constructor(public formBuilder: FormBuilder, private apiService: ApiService,
    private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router) { }

  ngOnInit() {
    this.slideOneForm = this.formBuilder.group({
      empresa: ['', Validators.required],
      segmento: ['', Validators.required],
      estado: ['', Validators.required],
      cidade: ['', Validators.required],
      site: ['', Validators.required],
      cnpj: [''],
      endereco: ['', Validators.required],
      numero: ['', Validators.required],
      telefone: ['', Validators.required],
      nota: ['5'],
      responsavel: [''],
      password: ['', Validators.required]
    });

    this.jsonArrayEstados = [];
  }

  filtrarCidades(uf) {
    this.jsonCidadeEstado = [];
    for (var i = 0; i < this.jsonArrayCidades.length; i++) {
      if (this.jsonArrayCidades[i].uf === uf) {
        this.jsonCidadeEstado.push({ cidade: this.jsonArrayCidades[i].cidade });
      }
    }
  }

}
